import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{ offset: number }>()(
  (theme, { offset }) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(3),
      marginTop: theme.spacing(3),
    },
    scrollTopMargin: {
      scrollMarginTop: `${offset}px`,
      gap: theme.spacing(3),
      display: 'flex',
      flexDirection: 'column',
    },
  })
)
